const $ = require("jquery");
const _ = require("lodash");

function setupFormPopUpBox() {
  const $trigger = $("#form-popup-box-trigger");

  if ($trigger.length) {
    let scrollDistance = 0;

    let lastScrollY = window.scrollY;
    const scrollListener = _.throttle(
      () => {
        scrollDistance += Math.abs(lastScrollY - window.scrollY);
        lastScrollY = window.scrollY;

        const scrolledHalfOfThePage = window.scrollY > $(document.body).height() / 2 - window.innerHeight;

        if (scrollDistance > 1000 || scrolledHalfOfThePage) {
          document.removeEventListener("scroll", scrollListener);

          const popupBoxSeen = sessionStorage.getItem("popupBoxSeen");
          if (!popupBoxSeen) {
            sessionStorage.setItem('popupBoxSeen', 'true');
            $trigger.click();
          }
        }
      },
      300
    );

    document.addEventListener("scroll", scrollListener);
  }
}

module.exports = setupFormPopUpBox;
